import { LAYOUT } from '@admin/router/constant'

// 管理系统路由
const crowdRouter = {
  path: '/crowd',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: 'cdp-field-list',
      name: 'cdpFieldList',
      component: () => import('@admin/views/system/cdpFieldList/index.vue'),
      meta: { helpUrl: '', title: '圈选字段配置' },
    },
  ],
}

export default [crowdRouter]
